<template>
  <section class="content-task-register">
    <Breadcrumb :links="links" :data="dataProps"/>
    <form class="content-task-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" name="name" v-model="task.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedMeditation && selectedMeditation !== ''}">
            <select v-model="selectedMeditation" disabled required>
              <option :value="meditation.id">{{ meditation.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedNarration && selectedNarration !== ''}">
            <select v-model="selectedNarration" required>
              <option value="" selected disabled>Selecione o narrador</option>
              <option v-for="narration in narrations.data" :key="narration.id" :value="narration.id">{{ narration.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12">
          <UploadAudio :image="'microfone.png'"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadAudio from '@/components/uploadAudio/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tasks',
          routerName: 'MeditationTasks'
        },
        {
          name: 'Nova Tarefa',
          routerName: 'MeditationRegisterTask'
        },
      ],
      selectedMeditation: '',
      selectedNarration: '',
      task: {
        id_user: '',
        id_meditation: '',
        id_meditation_narration: '',
        name: '',
        time: '',
        audio: '',
        audio_name: '',
        is_premium: false,
      },
      taskParams: this.$route.params,
      dataProps: { module: 'Meditation' },
    }
  },
  computed: {
    ...mapGetters({
      meditations: 'Meditation/meditations',
      meditation: 'Meditation/meditation',
      taskData: 'Meditation/task',
      narrations: 'Meditation/narrations',
      isPremium: 'Meditation/isPremium',
      user: 'User/user',
      audio: 'audio'
    }),
  },
  components: {
    Breadcrumb,
    UploadAudio
  },
  methods: {
    ...mapActions('Meditation', ['consultPlans', 'registerTask', 'consultTasks', 'consultNarrations', 'setDataDefault']),
    ...mapActions(['setAudio']),
    async handleSubmit(){
      let message = this.task?.id ? 'Tarefa editada com sucesso!' : 'Tarefa cadastrada com sucesso!';


      this.task.id_user = this.user.id;
      this.task.id_meditation = this.selectedMeditation;
      this.task.id_meditation_narration = this.selectedNarration;
      this.task.is_premium = this.isPremium;
      this.task.audio = this.audio?.blob ?? await this.dowloadFile();
      this.task.audio_name = this.audio?.name;
      this.task.time = !this.audio.time ? this.task.time : this.convertSecondsForTime(this.audio.time);

      await this.registerTask(this.task);
      this.$router.push({ name: 'MeditationTasks' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
    async dowloadFile() {
      try {
        // Baixa o conteúdo do arquivo MP3 da URL
        const response = await fetch(this.audio.audio_path);
        const mp3ArrayBuffer = await response.arrayBuffer();

        // Criar um Blob
        return new Blob([mp3ArrayBuffer], { type: 'audio/mp3' });

      } catch (error) {
        console.error('Erro ao baixar o arquivo MP3:', error);
      }
    },
    convertSecondsForTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsRemaining = seconds % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsRemaining.toFixed(6)}`;
    }
  },
  async mounted() {
    this.selectedMeditation = this.meditation.id;
    await this.consultNarrations();
    this.setAudio(null);
    if (this.taskParams?.idTask) {
      await this.consultTasks(this.taskParams);
      this.task = this.taskData;
      this.setDataDefault(['SET_IS_PREMIUM', this.task.is_premium]);
      this.selectedNarration = this.task.id_meditation_narration;
      this.dataProps = {
        name: this.task.name,
        id: this.task.id,
        id_meditation: this.task.id_meditation,
        module: 'Meditation',
        type: 'MeditationTask'
      };
      let obj = {
        name: this.task.audio_name,
        url: this.task.audio_path,
      };
      this.setAudio(obj);
      this.links[1].name = this.task.name;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-task-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
